import styled from 'styled-components';

export const Spacing = styled.div`
    padding: 80px 0 0;
    
    @media screen and (max-width: 768px) {
        padding: 40px 0 0;
    }
`;